import { useMutation } from "@apollo/client"
import { SEASON_UPDATE, SEASON_CREATE } from "../queries/adminQueries"

export interface SeasonUpdateInput {
  id: number
  name: string
  description?: string
  startDate: string
  endDate: string
  isActive: boolean
  isArchived: boolean
  gameId: number
}

export const useSeasonUpdate = () => {
  const [updateSeason, { loading, error }] = useMutation(SEASON_UPDATE)

  const handleUpdateSeason = async (input: SeasonUpdateInput) => {
    const { data } = await updateSeason({
      variables: { SeasonUpdateInput: input },
    })
    return data?.SeasonUpdate
  }

  return {
    updateSeason: handleUpdateSeason,
    loading,
    error,
  }
}

export const useSeasonCreate = () => {
  const [createSeason, { loading, error }] = useMutation(SEASON_CREATE)

  const handleCreateSeason = async (input: SeasonUpdateInput) => {
    const { data } = await createSeason({
      variables: {
        SeasonCreateInput: {
          name: input.name,
          description: input.description,
          startDate: input.startDate,
          endDate: input.endDate,
          isActive: input.isActive,
          gameId: input.gameId,
        },
      },
    })
    return data?.SeasonCreate
  }

  return {
    createSeason: handleCreateSeason,
    loading,
    error,
  }
}
